import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { userService } from '../../../services/UserService';
import { tenantQueryKeys } from '../tenantQueryKeys';

export function useTenantUserLabelsQuery(userId: string | undefined) {
  const { user } = useAuth();
  const isEnabled = Boolean(user) && Boolean(userId);

  return useQuery({
    queryKey: tenantQueryKeys.userLabels(userId ?? ''),
    enabled: isEnabled,
    queryFn: () => {
      if (!userId) {
        throw new Error('userId is required');
      }
      return userService.listUserLabels(userId);
    },
  });
}
